/**
 * PublicPrivacyLinks — the shared "Privacy · Privacy Choices" secondary-link
 * pair that every eligible public customer surface embeds inside its existing
 * footer/utility area (§2 / §11 / §17). Low-emphasis by contract.
 *
 * Do NOT include on internal Owner/staff surfaces (§13).
 */

import React from "react";
import { Link } from "react-router-dom";
import { PrivacyChoicesControl } from "./PrivacyChoicesControl";

/**
 * @param {Object} props
 * @param {"light"|"dark"|"muted"} [props.tone] - visual tone of the link
 *   pair so it inherits the surrounding footer palette without adding a
 *   competing color. Default "muted" for stone/gray footers.
 * @param {string} [props.className] - extra utility classes on the wrapper.
 */
export function PublicPrivacyLinks({ tone = "muted", className = "" }) {
  const toneClass =
    tone === "dark"
      ? "text-gray-400 hover:text-gray-200"
      : tone === "light"
      ? "text-white/70 hover:text-white"
      : "text-muted-foreground hover:text-foreground";
  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs ${toneClass} ${className}`}
      data-testid="public-privacy-links"
    >
      <Link
        to="/privacy"
        className="underline-offset-2 hover:underline"
        data-testid="public-privacy-link"
      >
        Privacy
      </Link>
      <span aria-hidden="true">·</span>
      <PrivacyChoicesControl triggerClassName="text-inherit" />
    </div>
  );
}

export default PublicPrivacyLinks;
